import { PayoutValue } from '@app/shared/models/contracts/enums/shared-enums';
import { enumToOptions } from '@app/shared/helpers';

export const PAYOUT_VALUE_OPTIONS = enumToOptions(PayoutValue);
